// src/components/VideoCall/VideoPlayer.js

import React, { useEffect, useRef } from 'react';
import './VideoPlayer.css';

const VideoPlayer = ({ track, name, isMuted, isCamOff, isScreenSharing, onClick, isEnlarged }) => {
    const videoRef = useRef(null);

    useEffect(() => {
    if (videoRef.current && track && typeof track.play === "function") {
        // Always clear old video
        videoRef.current.innerHTML = "";
        try {
            track.play(videoRef.current);
        } catch (err) {
            console.warn("Track play error:", err);
        }
    }

    return () => {
        if (track && typeof track.stop === "function") {
            try {
                track.stop();
            } catch (err) {
                console.warn("Track stop error:", err);
            }
        }
    };
}, [track, isEnlarged]);


    const showAvatar = isCamOff || !track;
    const videoContainerClass = showAvatar ? 'hidden' : 'video-player__video';
    const avatarClass = showAvatar ? 'video-player__avatar' : 'hidden';

    return (
        <div
            className={`video-player-container ${isEnlarged ? 'enlarged' : ''}`}
            onClick={onClick}
        >
            <div ref={videoRef} className={videoContainerClass}></div>
            <div className={avatarClass}>
                {name ? name.charAt(0).toUpperCase() : 'U'}
            </div>
            <div className="video-player__name">{isScreenSharing ? `${name} (Screen)` : name}</div>
        </div>
    );
};

export default VideoPlayer;